import React, { FC, memo } from 'react';

import EmptyState from 'application/components/EmptyState';

import { CompanyReportTypeFragment } from 'domain/api/graphql/generated';

import ReportCard from '../ReportCard';

import styles from './index.module.scss';
import { TEXTS } from './texts';

interface ReportsListProps {
  emptyTitle?: string;
  reports: CompanyReportTypeFragment[];
  setIsEmptyTabClass: (value: boolean) => void;
}

const ReportsList: FC<ReportsListProps> = ({ reports, emptyTitle, setIsEmptyTabClass }) => {
  if (!reports.length) {
    setIsEmptyTabClass(true);

    return (
      <EmptyState>
        {TEXTS.EMPTY_TEXT}
        <br />
        {TEXTS.EMPTY_TEXT_HINT}
      </EmptyState>
    );
  }

  return (
    <section className={styles.ReportsList}>
      <div className={styles.ReportsListContainer}>
        {reports.map((report) => {
          const { dateFrom, dateTo, id, reportType, status, title, reportFileUri, rightholderId } = report;
          return (
            <ReportCard
              key={id}
              dateFrom={dateFrom}
              emptyReportTitle={emptyTitle}
              title={title}
              dateTo={dateTo}
              status={status}
              id={id}
              reportType={reportType}
              reportFileUri={reportFileUri}
              rightholderId={rightholderId}
            />
          );
        })}
      </div>
    </section>
  );
};

export default memo(ReportsList);
